module.exports = __webpack_public_path__ + "images/pickle-with-glasses-ef223b74fbcb8b15e09e6f1a20300a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pickles/pickle-with-glasses.png
// module id = Gmv2
// module chunks = 0